import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { detectBankAccountLinked } from '../../../Profile/ProfileHelper';
import { FormField } from '../../../../forms/formField/index';
import { normalizeIBANNumber } from '../../../../helpers/normalizers';
import messages from './LinkBankAccount.messages';
import styles from './LinkDEBankAccount.module.css';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => ({
    isPendingBankAccount: state?.api?.payment_method?.pending,
    hasLinkedBankAccount: detectBankAccountLinked(
        state?.api?.payment_method?.data
    )
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const LinkDEBankAccountForm = ({
    isPendingBankAccount,
    hasLinkedBankAccount
}: PropsFromRedux) => {
    return (
        <>
            <FormField
                name="iban"
                data-testid="iban-input"
                label={<FormattedMessage {...messages.iban} />}
                normalize={normalizeIBANNumber}
                className={styles.iban}
                disabled={hasLinkedBankAccount || isPendingBankAccount}
            >
                {isPendingBankAccount ? (
                    <div
                        className={styles.pendingIBAN}
                        data-testid="iban-loading"
                    />
                ) : null}
            </FormField>

            <hr className={styles.divider} />

            <div className={styles.mandateTitle}>
                SEPA-Basislastschriftmandat für wiederkehrende Zahlungen
            </div>

            <FormField
                className={styles.mandateCheckbox}
                name="directDebitMandate"
                data-testid="direct-debit-mandate-checkbox"
                type="checkbox"
                label={
                    <>
                        Ich ermächtige iwoca Management S.à.r.l. (Gläubiger-ID:
                        LU72ZZZ0000000000000001848) und Stripe Payments Europe
                        Ltd., unseren Zahlungsdienstleister, Zahlungen von
                        meinem oben angegebenen Konto mittels Lastschrift
                        einzuziehen. Zugleich weise ich mein Kreditinstitut an,
                        die von Stripe Payments Europe Ltd. im Auftrag von iwoca
                        Management S.à.r.l. auf mein Konto gezogenen
                        Lastschriften einzulösen.
                        <br />
                        <br />
                        Weiterhin erkläre ich mich damit einverstanden, die
                        Vorabankündigung bis spätestens 3 Tage vor
                        Zahlungseinzug zu erhalten. Meine Rechte kann ich den
                        Bedingungen meines Kreditinstituts entnehmen.
                        <br />
                        <br />
                        Hinweis: Ich kann innerhalb von acht Wochen, beginnend
                        mit dem Belastungsdatum, die Erstattung des belasteten
                        Betrages verlangen. Es gelten dabei die mit meinem
                        Kreditinstitut vereinbarten Bedingungen.
                        <br />
                        <br />
                        Für mehr Informationen lesen Sie gern auch den{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://stripe.com/en-gb-de/privacy#translation"
                        >
                            Datenschutzhinweis
                        </a>{' '}
                        von Stripe.
                    </>
                }
            />
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(LinkDEBankAccountForm);
